<template>
	<li>
		<a
			:href="url"
			:target="target"
			:rel="rel"
			class="no-submenu link-menu"
			:class="className"
			@click="clicked"
		>
			<img v-if="imagePath" :src="imagePath" :alt="alt ? alt : title" :class="className" />
			{{ title }}
		</a>
	</li>
</template>
<script>
export default {
	name: 'Link',
	props: {
		title: String,
		url: { type: String, default: '#' },
		target: { type: String, default: '_self' },
		rel: { type: String, default: 'noopener noreferrer' },
		image: { type: String, default: null },
		className: { type: String, default: '' },
		alt: { type: String, default: '' },
		method: String,
	},
	computed: {
		imagePath() {
			return this.image
				? require('../../assets/img/' + this.image)
				: false
		},
		langLink() {
			if (this.title == 'lang') {
				return this.url
			}
			return this.url
		},
	},
	methods: {
		clicked() {
			if (this.method) {
				this.$emit(this.method)
			}
		},
	},
}
</script>

<style scoped lang="scss">
a {
	&.lang {
		width: 36px;
		text-align: center;
		margin-top: -4px;
		border: 2px solid $blueTheme;
		text-transform: uppercase;
		padding: 4px;
	}
}

img {
	height: 25px;
	width: auto;
	padding: 0;

	&.contact {
		height: 20px;
		padding-right: 5px;
	}
}
</style>
